import { render, staticRenderFns } from "./TicketsLeftPopupModal.vue?vue&type=template&id=08d5df00&scoped=true&"
import script from "./TicketsLeftPopupModal.vue?vue&type=script&lang=js&"
export * from "./TicketsLeftPopupModal.vue?vue&type=script&lang=js&"
import style0 from "./TicketsLeftPopupModal.vue?vue&type=style&index=0&id=08d5df00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d5df00",
  null
  
)

export default component.exports